export default function MobileView() {
  return (
    <div className="mobile-dashboard-message bg-white p-5 rounded-xl  text-center flex flex-col gap-4">
      <h3>Mobile dashboard coming soon.</h3>
      <h5>Log in using desktop to use application.</h5>
    </div>
  );
}
